export const CHANGE_DISTANCE_FORM = 'CHANGE_DISTANCE_FORM';
export const CHANGE_DISTANCE_FIELD = 'distance';
export const CREATE_CHANGE_DISTANCE_REQUEST = 'CREATE_CHANGE_DISTANCE_REQUEST';
export const LOAD_CHANGE_DISTANCE_DETAILS = 'LOAD_CHANGE_DISTANCE_DETAILS';
export const CHANGE_DISTANCE_TOKEN_PARAM = 'change_distance_token';
export const CHANGE_DISTANCE_STORAGE_KEY = 'change_distance_request';

export const CHANGE_DISTANCE_DETAILS_UNKNOWN = 'CHANGE_DISTANCE_DETAILS_UNKNOWN';

export const CHANGE_DISTANCE_ERROR_KEYS: { [code: string]: TranslationLockedKeys } = {
  CHANGE_DISTANCE_NOT_ALLOWED: 'changeDistance.error.notAllowed',
  CHANGE_DISTANCE_NOT_ELIGIBLE: 'changeDistance.error.notEligible',
  CHANGE_DISTANCE_ALREADY_REGISTERED: 'changeDistance.error.alreadyRegistered',
  CHANGE_DISTANCE_REGISTRATION_CLOSED: 'changeDistance.error.registrationClosed',
  CHANGE_DISTANCE_NO_CAPACITY: 'changeDistance.error.noCapacity',
};

export const CHANGE_DISTANCE_DETAILS_ERROR_KEYS: { [code: string]: TranslationLockedKeys } = {
  CHANGE_DISTANCE_TOKEN_EXPIRED: 'changeDistance.registration.expired',
  CHANGE_DISTANCE_ALREADY_CONFIRMED: 'changeDistance.registration.alreadyConfirmed',
  CHANGE_DISTANCE_REJECTED: 'changeDistance.registration.rejected',
  [CHANGE_DISTANCE_DETAILS_UNKNOWN]: 'changeDistance.registration.notFound',
};
